"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const svgIcons_1 = require("../../../../svgIcons");
const core_1 = require("@material-ui/core");
const NoResult = (props) => {
    return (react_1.default.createElement(core_1.Box, { display: "block", textAlign: "center", style: { height: "100vh" }, className: props.className },
        react_1.default.createElement(svgIcons_1.NoResultIcon, { style: { fontSize: '22px', marginTop: '60px' } }),
        react_1.default.createElement(core_1.Box, { p: 1 }, "No results to show.")));
};
exports.default = NoResult;
